import Vue from "vue";

export default {
  install() {
    Vue.prototype.$loading = function (event) {
      this.$store.commit("LOADING", event);
    };
    Vue.prototype.$notify = function ({ title, text, type }) {
      this.$store.commit("NOTIFY", {
        title,
        text,
        type,
      });
      setTimeout(() => {
        this.$store.commit("NOTIFY", {});
      }, 5000);
    };
  },
};
